<script>
import { componentStore } from "@common/componentStore/componentStore";
import { library } from "@common/library/library";
import { recordStore } from "@common/recordStore";

let editorSettings = {};

const vmsGridColumnSearchMultiConfig = {
    cId: "vmsGridColumnSearchMulti",
    cType: "vmsGridColumnSearchMulti",
    cTitle: "VMS Grid Column Search Multi",
    cTemplate: `<div class="vms-grid-column-search-multi" :class="{'show-border': !hideBorder}" :id="'vmsGridColumnSearchMultiWrapper' + cId">
                    <control
                        v-if="itemsLoaded"
                        :key="'VMS_GRID_CLUMN_SEARCH_MULTI__' + cId + '_' + componentKey"
                        :name="'VMS_GRID_CLUMN_SEARCH_MULTI__' + cId"
                        :ref="'VMS_GRID_CLUMN_SEARCH_MULTI__' + cId"
                        :value="selectedGridColumnSearchMulti" 
                        :items="vmsGridColumnSearchMultiItems" 
                        @update:value="selectedGridColumnSearchMulti = $event"
                    ></control>
                </div>`,
    controls: [
        {
            name: 'VMS_GRID_CLUMN_SEARCH_MULTI',
            type: 'multiselect',
            ref: 'VMS_GRID_CLUMN_SEARCH_MULTI',
            allowFiltering: false,
            filterType: 'Contains',
            filtering: 'filtering',
            allowMultiSelection: true,
            fields: {
                text: 'title',
                value: 'id'
            },
            hideSelectedItem: false,
            closePopupOnSelect: false,
            showDropDownIcon: true,
            default: [],
            onchange: 'filterChanged',
            mode: "CheckBox",
            popupWidth: '200px',
            doNotSetItemsOnUpdate: true,
            changeOnBlur: false,
            valueTemplate: `<span>{{data.title}}</span>`
        },
    ]
};

let vmsGridColumnSearchMultiCmp = {
    name: 'vmsGridColumnSearchMulti',
    props: {
        columnName: {
            type: [String],
            default: ''
        },
        columnId: {
            type: [String],
            default: ''
        },
        perspectiveId: {
            type: [String, Number],
            default: 1
        },
        selectedValues: {
            type: String,
            default: ''
        },
        selectedValuesUpdate: {
            default: false
        },
        allValues: {
            type: String,
            default: ''
        },
        hideBorder: {
            type: [Boolean],
            default: false
        },
        processActionFnc: {
            default: false
        }
    },
    editorSettings,
    data() {
        return {
            initialVmsGridColumnSearchMulti: [],
            vmsGridColumnSearchMultiItems: [],
            selectedGridColumnSearchMulti: [],
            itemsLoaded: false,
            componentKey: 0
        };
    },
    computed: {},
    methods: {
        async onLoad() {
            this.loadInitialSelectedValues();
            library.showLoadingIndicator('vmsGridColumnSearchMultiWrapper' + this.cId);
            await this.loadAllItemsOnce();
            library.hideLoadingIndicator('vmsGridColumnSearchMultiWrapper' + this.cId);
            this.registerExternalApi();
        },

        loadInitialSelectedValues() {
            let selectedItems = this.parseSelectedValues();
            if (!Array.isArray(selectedItems)) {
                selectedItems = [];
            }
            selectedItems = selectedItems.map((tmp) => ({
                id: String(tmp.id),
                title: tmp.title || String(tmp.id)
            }));
            this.initialVmsGridColumnSearchMulti = library.cloneObj(selectedItems);
            this.vmsGridColumnSearchMultiItems = library.cloneObj(selectedItems);
            this.$nextTick(() => {
                this.selectedGridColumnSearchMulti = selectedItems.map((tmp) => tmp.id);
                this.$nextTick(() => {
                    this.componentKey++;
                    this.updateHiddenInput();
                });
            });
        },

        registerExternalApi() {
            if (!window.vmsGridColumnSearchMultiInstances) {
                window.vmsGridColumnSearchMultiInstances = {};
            }
            if (typeof window.vmsGridColumnSearchMultiInstances[this.perspectiveId] === 'undefined') window.vmsGridColumnSearchMultiInstances[this.perspectiveId] = {};
            window.vmsGridColumnSearchMultiInstances[this.perspectiveId][this.columnId] = this;
        },

        parseSelectedValues() {
            if (Array.isArray(this.selectedValues)) {
                return this.selectedValues;
            }
            if (typeof this.selectedValues === 'string' && this.selectedValues.trim()) {
                try {
                    return JSON.parse(this.selectedValues);
                } catch (e) {
                    return [];
                }
            }
            return [];
        },

        parseAllValues() {
            if (Array.isArray(this.allValues)) {
                return this.allValues;
            }
            if (typeof this.allValues === 'string' && this.allValues.trim()) {
                try {
                    return JSON.parse(this.allValues);
                } catch (e) {
                    return [];
                }
            }
            return [];
        },

        setAllItems(filterItems) {
            if (!Array.isArray(filterItems)) {
                filterItems = [];
            }
            filterItems = filterItems.map((tmp) => ({
                id: String(tmp.id),
                title: tmp.title || String(tmp.id)
            }));
            let selectedItems = this.initialVmsGridColumnSearchMulti.filter((tmp) => this.selectedGridColumnSearchMulti.indexOf(tmp.id) !== -1);
            let mergedItems = [...selectedItems];
            for (let i in filterItems) {
                let exists = mergedItems.find((tmp) => tmp.id === filterItems[i].id);
                if (!exists) {
                    mergedItems.push(filterItems[i]);
                }
            }
            this.initialVmsGridColumnSearchMulti = library.cloneObj(mergedItems);
            this.vmsGridColumnSearchMultiItems = library.cloneObj(mergedItems);
        },

        async loadAllItemsOnce() {
            // if (this.itemsLoaded) return;
            let tmpItems = [];
            let propItems = this.parseAllValues();
            if (Array.isArray(propItems) && propItems.length) {
                tmpItems = library.cloneObj(propItems);
            }
            let response = await configStore.getDropdownSearchOptions(this.columnName, this.perspectiveId);
            if (response) {
                let filterItems = [];
                if (Array.isArray(response?.items)) {
                    filterItems = response.items;
                }
                tmpItems = library.cloneObj(filterItems);
            }
            if (Array.isArray(tmpItems)) {
                this.setAllItems(tmpItems);
            }
            this.itemsLoaded = true;
        },

        filterItemsOnFrontend(searchText) {
            let value = String(searchText || '').toLowerCase();
            if (!value) {
                this.vmsGridColumnSearchMultiItems = library.cloneObj(this.initialVmsGridColumnSearchMulti);
                return;
            }
            this.vmsGridColumnSearchMultiItems = this.initialVmsGridColumnSearchMulti.filter((tmp) => String(tmp.title || '').toLowerCase().indexOf(value) !== -1);
        },

        async filtering(args) {
            let searchText = args?.text || '';
            this.filterItemsOnFrontend(searchText);
            if (args && typeof args.updateData === 'function') {
                args.updateData(this.vmsGridColumnSearchMultiItems);
            }
        },

        isSpecialEmptyValue(id) {
            return String(id) === '-1' || String(id) === '-2';
        },

        filterChanged() {
            let selected = this.selectedGridColumnSearchMulti || [];
            if (!Array.isArray(selected)) {
                selected = [selected];
            }
            selected = selected.map((tmp) => String(tmp));
            let specialSelected = selected.filter((tmp) => this.isSpecialEmptyValue(tmp));
            let normalSelected = selected.filter((tmp) => !this.isSpecialEmptyValue(tmp));
            if (specialSelected.length && normalSelected.length) {
                let lastSelected = selected[selected.length - 1];
                if (this.isSpecialEmptyValue(lastSelected)) {
                    this.selectedGridColumnSearchMulti = [lastSelected];
                } else {
                    this.selectedGridColumnSearchMulti = normalSelected;
                }
            } else if (specialSelected.length > 1) {
                this.selectedGridColumnSearchMulti = [specialSelected[specialSelected.length - 1]];
            }
            this.updateHiddenInput();
        },

        getSelectedItemsForJson() {
            let selected = this.selectedGridColumnSearchMulti || [];
            if (!Array.isArray(selected)) {
                selected = [selected];
            }
            selected = selected
                .map((tmp) => String(tmp))
                .filter((tmp) => tmp !== '');
            if (!selected.length) {
                return [];
            }
            return this.initialVmsGridColumnSearchMulti.filter((tmp) => selected.indexOf(String(tmp.id)) !== -1);
        },

        updateHiddenInput() {
            let selectedItems = this.getSelectedItemsForJson();
            let newValue = selectedItems.length ? JSON.stringify(selectedItems) : '';
            if (typeof this.selectedValuesUpdate === 'function') {
                this.selectedValuesUpdate(newValue);
                return;
            }

            let hiddenInput = document.getElementById('gridSearchValue_' + this.columnId);
            if (!hiddenInput) {
                return;
            }
            if (hiddenInput.value === newValue) {
                return;
            }
            hiddenInput.value = newValue;
            if ("createEvent" in document) {
                let evt = document.createEvent("HTMLEvents");
                evt.initEvent("change", false, true);
                hiddenInput.dispatchEvent(evt);
            } else {
                hiddenInput.fireEvent("onchange");
            }
        },

        clearSelection() {
            this.selectedValues = [];
            this.selectedGridColumnSearchMulti = [];
            this.filterChanged();
            this.filterItemsOnFrontend('');
        },

        setSelection(selectedItems) {
            if (!Array.isArray(selectedItems)) {
                selectedItems = [];
            }
            selectedItems = selectedItems.map((tmp) => ({
                id: String(tmp.id),
                title: tmp.title || String(tmp.id)
            }));
            this.selectedGridColumnSearchMulti = selectedItems.map((tmp) => tmp.id);
            let mergedItems = library.cloneObj(this.initialVmsGridColumnSearchMulti);
            for (let i in selectedItems) {
                let exists = mergedItems.find((tmp) => String(tmp.id) === String(selectedItems[i].id));
                if (!exists) {
                    mergedItems.push(selectedItems[i]);
                }
            }
            this.initialVmsGridColumnSearchMulti = library.cloneObj(mergedItems);
            this.vmsGridColumnSearchMultiItems = library.cloneObj(mergedItems);
            this.updateHiddenInput();
        },

        processAction(act) {
            switch (act) {
                case 'trapEnter':
                    if (typeof this.processActionFnc === 'function') this.processActionFnc(act);
                    else if (typeof listEngineAction === 'function') listEngineAction('find');
                    break;
            }
        },
    }
};

componentStore.initComponent(vmsGridColumnSearchMultiCmp, vmsGridColumnSearchMultiConfig);
export { vmsGridColumnSearchMultiCmp, vmsGridColumnSearchMultiConfig };
export default vmsGridColumnSearchMultiCmp;

</script>

<style scoped>
    :deep(.vms-grid-column-search-multi) {
        display: flex;
        width: 100%;
    }
    /* :deep(.show-border .e-multiselect.e-control-wrapper) {
        border: 1px solid #bdbdbd !important;
        padding-left: 5px !important;
    } */
</style>
